module.exports = __webpack_public_path__ + "img/SES_40_00_075_099.8f0059de.jpg";